import React from 'react'
import PropTypes from 'prop-types'
import { GeolocationApiContext } from '../contexts/GeolocationApiContext'
import { withApi, extractData } from './ApiProvider'

export const withGeolocationApi = ComponentToWrap => {
  const WrappedComponent = (props) => {
    return (
      <GeolocationApiContext.Consumer>
        {value => (
          <ComponentToWrap {...props} geolocationApi={value} />
        )}
      </GeolocationApiContext.Consumer>
    )
  }

  WrappedComponent.displayName = `withGeolocationApi(${ComponentToWrap.displayName || ComponentToWrap.name})`
  return WrappedComponent
}

const GeolocationApiProviderComponent = (props) => {
  const { children, apiWrapper } = props

  const endpointsProvider = (baseURL) => {
    return {
      getCountries: `${baseURL}/api/countries`,
      getRegions: (countryCode) => (`${baseURL}/api/countries/${encodeURIComponent(countryCode)}/regions`)
    }
  }

  const endpoints = endpointsProvider(process.env.GEOLOCATION_API_URL)

  //  TODO
  const getCountries = () => {
    const url = endpoints.getCountries

    return apiWrapper({
      method: 'get',
      url: url
    }).then(extractData)
  }

  const getRegions = (countryCode) => {
    const url = endpoints.getRegions(countryCode)

    return apiWrapper({
      method: 'get',
      url: url
    }).then(extractData)
  }

  //  TODO

  const geolocationApi = {
    getCountries,
    getRegions
  }

  return (
    <GeolocationApiContext.Provider value={geolocationApi}>
      {children}
    </GeolocationApiContext.Provider>
  )
}

GeolocationApiProviderComponent.defaultProps = {
  children: null
}

GeolocationApiProviderComponent.propTypes = {
  children: PropTypes.node,
  apiWrapper: PropTypes.func.isRequired
}

export const GeolocationApiProvider = withApi(GeolocationApiProviderComponent)
